export default {
    mounted() {
        switch (this.$options.name) {
            case 'PartnerFields':
                this.person = 'partner';
                this.$watch('partner.gender', () => {
                    if (this[this.person].tempPreTitle) {
                        this.setTitleFields(this[this.person].tempPreTitle, 'pre');
                    }
                    if (this[this.person].tempPostTitle) {
                        this.setTitleFields(this[this.person].tempPostTitle, 'post');
                    }
                });
                this.$watch('partner.tempPreTitle', () => {
                    this.setTitleFields(this[this.person].tempPreTitle, 'pre');
                });
                this.$watch('partner.tempPostTitle', () => {
                    this.setTitleFields(this[this.person].tempPostTitle, 'post');
                });
                break;

            case 'InterpreterFields':
                this.person = 'interpreter';
                this.$watch('interpreter.gender', () => {
                    if (this[this.person].tempPreTitle) {
                        this.setTitleFields(this[this.person].tempPreTitle, 'pre');
                    }
                    if (this[this.person].tempPostTitle) {
                        this.setTitleFields(this[this.person].tempPostTitle, 'post');
                    }
                });
                this.$watch('interpreter.tempPreTitle', () => {
                    this.setTitleFields(this[this.person].tempPreTitle, 'pre');
                });
                this.$watch('interpreter.tempPostTitle', () => {
                    this.setTitleFields(this[this.person].tempPostTitle, 'post');
                });
                break;

            case 'TrustPersonFields':
                this.person = 'trustPerson';
                this.$watch('trustPerson.gender', () => {
                    if (this[this.person].tempPreTitle) {
                        this.setTitleFields(this[this.person].tempPreTitle, 'pre');
                    }
                    if (this[this.person].tempPostTitle) {
                        this.setTitleFields(this[this.person].tempPostTitle, 'post');
                    }
                });
                this.$watch('trustPerson.tempPreTitle', () => {
                    this.setTitleFields(this[this.person].tempPreTitle, 'pre');
                });
                this.$watch('trustPerson.tempPostTitle', () => {
                    this.setTitleFields(this[this.person].tempPostTitle, 'post');
                });
                break;

            case 'WitnessFields':
                this.person = 'witness';
                this.$watch('witness.gender', () => {
                    if (this[this.person].tempPreTitle) {
                        this.setTitleFields(this[this.person].tempPreTitle, 'pre');
                    }
                    if (this[this.person].tempPostTitle) {
                        this.setTitleFields(this[this.person].tempPostTitle, 'post');
                    }
                });
                this.$watch('witness.tempPreTitle', () => {
                    this.setTitleFields(this[this.person].tempPreTitle, 'pre');
                });
                this.$watch('witness.tempPostTitle', () => {
                    this.setTitleFields(this[this.person].tempPostTitle, 'post');
                });
                break;
        }
    },

    methods: {
        searchPreTitleInput(searchQuery) {
            if (searchQuery.length) {
                searchQuery = searchQuery.toLowerCase();
                this.localPreTitles = _.filter(this.preTitles, title => {
                    let matchedKeywords = title.keyword.filter(key => key.toLowerCase().indexOf(searchQuery) >= 0);
                    return matchedKeywords.length;
                });
            } else {
                this.localPreTitles = this.preTitles;
            }
        },

        searchPostTitleInput(searchQuery) {
            if (searchQuery.length) {
                searchQuery = searchQuery.toLowerCase();
                this.localPostTitles = _.filter(this.postTitles, title => {
                    let matchedKeywords = title.keyword.filter(key => key.toLowerCase().indexOf(searchQuery) >= 0);
                    return matchedKeywords.length;
                });
            } else {
                this.localPostTitles = this.postTitles;
            }
        },
        setTitleFields(personTitles, suffix) {
            let arrInput = [];
            let arrShortTitle = [];
            let arrLongTitle = [];
            personTitles.forEach(title => {
                arrInput.push(title.input);
                arrShortTitle.push(title.short);
                switch (this[this.person].gender) {
                    case 'male':
                        arrLongTitle.push(title.full_male);
                        break;
                    case 'female':
                        arrLongTitle.push(title.full_female);
                        break;
                    default:
                        arrLongTitle.push(title.full_other)
                }
            })
            if (suffix === 'post') {
                this[this.person].post_title = arrInput.join(', ');
                this[this.person].post_title_short = arrShortTitle.join(', ');
                this[this.person].post_title_long = arrLongTitle.join(', ');
            } else {
                this[this.person].pre_title = arrInput.join(', ');
                this[this.person].pre_title_short = arrShortTitle.join(', ');
                this[this.person].pre_title_long = arrLongTitle.join(', ');
            }
        },
    },
}
